import isEqual from 'lodash/isEqual'

// An editor saves against a revision of the whole event, which any write to the event moves: a follow, a score, an announcement, a
// registration in another competition. After such a refusal the editor reads the event again and compares what its form saves, field by
// field, with the read its draft was opened on. `fields` lists each field as `[label, read => value]`; the labels of those that differ
// come back in that order. Only when none differs may the draft be saved on the new revision: the save sends every field, so it would
// put back whatever someone else changed meanwhile.
export const changedFields = (fields, opened, current) => fields.filter(([, value]) => !isEqual(value(opened), value(current))).map(([label]) => label)

const listed = labels => labels.length > 1 ? `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}` : labels[0]
// Why the draft can no longer be saved, naming what someone else changed (`changedFields`).
export const changedFieldsText = labels => `Someone else changed ${listed(labels)} after you opened this editor. Reload the current details to see them; `
  + 'reloading discards your draft.'
